import script from "./PlayingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayingCard.vue?vue&type=script&setup=true&lang=js"

import "./PlayingCard.vue?vue&type=style&index=0&id=f0b854d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0b854d8"]])

export default __exports__